<ng-container *ngIf="stageParticipantData">
    <div class="golf-aside">
        <div class="match-info-head text-white mb-0 bg-dark p-2 d-flex">
            &nbsp;
            <!--    <span class="font-weight-bold text-uppercase">Results of France GP</span>-->
            <!--    <a href="#" class="ml-auto small text-reset"><svg class="icon icon&#45;&#45;white icon&#45;&#45;12 mr-2"><use href="#icon-table"></use></svg>Standings</a>-->
        </div>
        <div class="mb-3 px-2 pb-4 bg-white">
            <div class="d-flex flex-row align-items-center mb-3 pt-3 border-top border-light2 position-relative">
                <img
                    *ngIf="stageParticipantData.logo; else elseLogo"
                    src="{{ stageParticipantData.logo }}"
                    alt=""
                    class="rounded-circle mr-2"
                    height="50"
                />
                <ng-template #elseLogo>
                    <img
                        *ngIf="stageParticipantData.iso"
                        src="/img/flags/1x1/{{ stageParticipantData.iso | lowercase }}.svg"
                        alt=""
                        class="rounded-circle mr-2"
                        height="50"
                    />
                    <img
                        *ngIf="!stageParticipantData.iso"
                        src="/img/default-avatar.png"
                        alt=""
                        class="rounded-circle mr-2"
                        height="50"
                    />
                </ng-template>
                <div>
                    <h5 class="font-weight-bold d-flex align-items-center flex-nowrap mb-1 app-text">
                        <a
                            [routerLink]="[
                                '/page/stage/participant',
                                sportName + '-' + sportId,
                                stageParticipantData.id
                            ]"
                            class="text-reset"
                            >{{ stageParticipantData.name }}<ng-container *ngIf="pageService.debug">
                            ({{ stageParticipantData.id }})
                        </ng-container></a
                        >
                        <!--                <div class="img-circle ml-2 rounded-circle">-->
                        <!--                    <img src="/img/default-avatar.png" alt="Roger Federer" class="rounded-circle mr-2" height="20">-->
                        <!--                </div>-->
                    </h5>
                    <a *ngIf="stageParticipantData?.team_id" [routerLink]="['/page/stage/participant', sportName + '-' + sportId, stageParticipantData.team_id]"
                        class="small text-reset">{{ stageParticipantData.team_name }}
                        <ng-container *ngIf="pageService.debug">
                            ({{ stageParticipantData.team_id }})
                        </ng-container>
                    </a>
                    <!--            <div class="small">-->
                    <!--                <span class="pr-1 pr-md-3 text-nowrap">Age: <span class="font-weight-bold">33</span></span>-->
                    <!--                <span class="pr-1 pr-md-3 text-nowrap">Season Rank: <span class="font-weight-bold">15</span></span>-->
                    <!--                <span class="pr-1 pr-md-3 text-nowrap">Team: <span class="font-weight-bold">Mercedes</span></span>-->
                    <!--            </div>-->
                </div>
                <!--        <button type="button" class="close close&#45;&#45;player" aria-label="Close">-->
                <!--            <span aria-hidden="true">&times;</span>-->
                <!--        </button>-->
            </div>

            <div class="table-responsive">
                <table class="table table-sm stage-table">
                    <thead>
                        <tr class="bg-light2">
                            <td class="small align-middle"></td>
                            <td class="small align-middle text-center">#</td>
                            <ng-container *ngIf="stageParticipantData.valueTypes.competitors; else elseBlock">
                                <ng-container *ngFor="let valueType of stageParticipantData.valueTypes.competitors">
                                    <td class="small align-middle text-center">
                                        {{ 'stagevaluetype.' + stageParticipantData.category + '_' + valueType | translate }}
                                    </td>
                                </ng-container>
                            </ng-container>
                            <ng-template #elseBlock>
                                <ng-container *ngFor="let valueType of stageParticipantData.valueTypes.teams">
                                    <td class="small align-middle text-center">
                                        {{ 'stagevaluetype.' + stageParticipantData.category + '_' + valueType | translate }}
                                    </td>
                                </ng-container>
                            </ng-template>
                        </tr>
                    </thead>

                    <tbody>
                        <tr *ngFor="let stage of stageParticipantData.stage">
                            <td class="text-nowrap">
                                <!-- <img src="/img/default-avatar.png" alt="Roger Federer" class="rounded-circle mr-2" height="24">-->
                                {{ stage.description }}
                            </td>
                            <td class="text-center">
                                <ng-container *ngIf="stage.position">{{ stage.position }}.</ng-container>
                            </td>
                            <ng-container *ngIf="stageParticipantData.valueTypes.competitors; else elseBlock">
                                <ng-container *ngFor="let valueType of stageParticipantData.valueTypes.competitors">
                                    <td class="text-center">
                                        <ng-container
                                            *ngIf="
                                        stageListService.translatableValues.includes(stage.values[valueType]);
                                        else rawValueType
                                    "
                                        >
                                            {{
                                                'web.stagevalue_' + stage.values[valueType] | lowercase | translate
                                            }} </ng-container
                                        ><ng-template #rawValueType>
                                        {{ stage.values[valueType] }}
                                    </ng-template>
                                    </td>
                                </ng-container>
                            </ng-container>
                            <ng-template #elseBlock>
                                <ng-container *ngFor="let valueType of stageParticipantData.valueTypes.teams">
                                    <td class="text-center">
                                        {{ stage.values[valueType] }}
                                    </td>
                                </ng-container>
                            </ng-template>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</ng-container>
